<ion-app>
  <ion-content [fullscreen]="true">

    <div
      *ngIf="showIdlePopup"
      class="idle-screen"
    >
      <div
        class="hex-container main-content"
      >
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="col">
          <section>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
            <article></article>
          </section>
        </div>
        <div class="main-content-container">
          <div
            [ngClass]="{
              'content-container': true,
              'mobile-landscape': isMobile && isLandscape
            }"
          >
            <div
              class="close-container"
              (click)="resetIdle()"
            >
              <img
                class="img-close"
                src="assets/img/close_icon_default.png"
                alt="Close icon"
              >
            </div>
            <img
              class="img-main"
              src="assets/img/is_that_you_bee.png"
              alt="Is that you bee"
            >
            <p class="idle-text">Is that you {{ profileData?.firstname }}?</p>
            <div class="action-container">
              <button
                type="button"
                class="btn-no"
                (click)="handleLogout()"
              >
                <img
                  class="img-action"
                  src="assets/img/no_icon_default.png"
                  alt="img-no"
                >
                <p>No</p>
              </button>
              <button
                type="button"
                class="btn-yes"
                (click)="resetIdle()"
              >
                <img
                  class="img-action"
                  src="assets/img/yes_icon_default.png"
                  alt="img-yes"
                >
                <p>Yes</p>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="showIABLoading"
      class="loading-screen"
    >
      <div
        [ngClass]="{
          'content-container': true,
          'mobile-landscape': isMobile && isLandscape
        }"
      >
        <div class="loading-img">
          <div id="loading-sprite-bee" class="sprite"></div>
        </div>
        <h5 class="loading-text text-pun">
          We are preparing the website for you now!
        </h5>
      </div>
    </div>

    <div
      *ngIf="showIABDialog"
      class="loading-screen"
    >
      <div class="content-container">
        <div class="loading-img">
          <div id="dialog-icon"><img width="100" [src]="dialog.icon" /></div>
        </div>
        <h5 class="loading-text text-pun">
          {{dialog.msg}}
        </h5>
        <button
          type="button"
          (click)="handleCloseDialog(dialog?.terminate)"
        >
          Okay
        </button>
      </div>
    </div>

    <div
      *ngIf="showLoadingScreen"
      class="loading-screen"
    >
      <div
        [ngClass]="{
          'content-container': true,
          'mobile-landscape': isMobile && isLandscape
        }"
      >
        <div class="loading-img">
          <img src="assets/img/bee_logging_out.png" alt="Bee Logout">
        </div>
        <h1 class="loading-text header">Logging you out</h1>
        <h5 class="loading-text">{{loadingPun}}</h5>
      </div>
    </div>
    <div id="main-menu">
      <div
        *ngIf="!(isMobile && !isLandscape)"
        [ngClass]="{
          'menu-list': true,
          'max-browser-width': isBrowserPlatform,
          'show-menu': showMenu,
          'mobile': isMobile,
          'portrait-view': !isMobile && !isLandscape
        }"
      >
        <div
          (click)="toggleMenu()"
          class="icon-holder"
        >
          <section>
            <article>
              <div class="background-container"></div>
            </article>
          </section>
          <svg class="close-list" xmlns="http://www.w3.org/2000/svg" width="24.284" height="24.284" viewBox="0 0 24.284 24.284">
            <g id="close_icon" transform="translate(-237.687 -23.729)">
              <line id="Line_4" data-name="Line 4" x1="26.342" transform="translate(240.516 26.558) rotate(45)" fill="none" stroke="#ffa700" stroke-linecap="round" stroke-width="4"/>
              <line id="Line_6" data-name="Line 6" x1="26.342" transform="translate(240.516 45.184) rotate(-45)" fill="none" stroke="#ffa700" stroke-linecap="round" stroke-width="4"/>
            </g>
          </svg>
        </div>
        <div routerLink="home" (click)="toggleMenu()">Home</div>
        <div routerLink="home/profile" (click)="toggleMenu()">Profile</div>
        <div routerLink="home/apps-list" (click)="toggleMenu()">Account</div>
        <div routerLink="home/help" (click)="toggleMenu()">Help</div>
        <div routerLink="home/about" (click)="toggleMenu()">About</div>
        <div
          class="logout-button"
          (click)="handleLogout()"
        >
          Log out
        </div>
      </div>
      <div
        *ngIf="isMobile && !isLandscape"
        [ngClass]="{
          'menu-list mobile': true,
          'show-menu': showMenu
        }"
      >
        <div
          (click)="toggleMenu()"
          class="icon-holder"
        >
          <section>
            <article>
              <div class="background-container"></div>
            </article>
          </section>
          <svg class="close-list" xmlns="http://www.w3.org/2000/svg" width="24.284" height="24.284" viewBox="0 0 24.284 24.284">
            <g id="close_icon" transform="translate(-237.687 -23.729)">
              <line id="Line_4" data-name="Line 4" x1="26.342" transform="translate(240.516 26.558) rotate(45)" fill="none" stroke="#ffa700" stroke-linecap="round" stroke-width="4"/>
              <line id="Line_6" data-name="Line 6" x1="26.342" transform="translate(240.516 45.184) rotate(-45)" fill="none" stroke="#ffa700" stroke-linecap="round" stroke-width="4"/>
            </g>
          </svg>
        </div>
        <div routerLink="home" (click)="toggleMenu()">Home</div>
        <div routerLink="home/profile" (click)="toggleMenu()">Profile</div>
        <div routerLink="home/apps-list" (click)="toggleMenu()">Account</div>
        <div routerLink="home/help" (click)="toggleMenu()">Help</div>
        <div routerLink="home/about" (click)="toggleMenu()">About</div>
        <div
          class="logout-button"
          (click)="handleLogout()"
        >
          Log out
        </div>
      </div>
      <div id="main-menu--container" class="row">
        <div
          id="main-hex--container"
          class="hide-display"
        >
          <div
            *ngIf="isMobile && !isLandscape"
            class="hex-container mobile"
          >
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article class="home-icon">
                  <div
                    (click)="handleNavigateApp()"
                    class="background-container"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="30.358" height="34.687" viewBox="0 0 30.358 34.687">
                      <g id="classhive_logo" data-name="classhive logo" transform="translate(-913.407 -1056.112)">
                        <g id="Group_235" data-name="Group 235" transform="translate(929.275 1065.167)">
                          <g id="Group_234" data-name="Group 234" transform="translate(4.214 2.523)">
                            <path id="Path_862" data-name="Path 862" d="M946.842,1076.8a4.005,4.005,0,0,1,.989,1.3,2.439,2.439,0,0,1,.226.742,2.33,2.33,0,0,1-.142,1.053,2.689,2.689,0,0,1-.5.9,1.689,1.689,0,0,1-.512.428,1.022,1.022,0,0,1-.6.161c-.288-.034-.474-.235-.717-.5a3.255,3.255,0,0,1-.511-.762,4.822,4.822,0,0,1-.418-1.514,4.982,4.982,0,0,1-.028-1.743c.1-.561.166-.911.425-1.037C945.526,1075.6,946.283,1076.287,946.842,1076.8Z" transform="translate(-938.542 -1070.862)" fill="#f8e3c9"/>
                            <path id="Path_863" data-name="Path 863" d="M940.809,1074.3a4.013,4.013,0,0,0-1.634.084,2.459,2.459,0,0,0-.712.307,2.341,2.341,0,0,0-.713.789,2.7,2.7,0,0,0-.363.963,1.7,1.7,0,0,0,0,.667,1.015,1.015,0,0,0,.264.562,1.2,1.2,0,0,0,.846.223,3.233,3.233,0,0,0,.912-.1,4.821,4.821,0,0,0,1.426-.657,5.008,5.008,0,0,0,1.35-1.1c.362-.44.589-.714.518-.994C942.578,1074.526,941.561,1074.394,940.809,1074.3Z" transform="translate(-937.355 -1070.61)" fill="#f8e3c9"/>
                            <path id="Path_864" data-name="Path 864" d="M942.885,1076.184c.4-.487.667-.809.566-1.207a.9.9,0,0,0-.55-.574,2.146,2.146,0,0,1,1.544.357,2.121,2.121,0,0,1,.6.638.894.894,0,0,0-.774-.042c-.37.18-.444.591-.558,1.212a5.237,5.237,0,0,0,.026,1.822,5.931,5.931,0,0,0,.251,1.124l-.059.068a3.62,3.62,0,0,1-.811.666,2.543,2.543,0,0,1-.843.361,2.258,2.258,0,0,1-.482.047l-.783.589-.055-1a2.9,2.9,0,0,1-.373-.669,3.168,3.168,0,0,1-.144-1.694,5.853,5.853,0,0,0,1.04-.542A5.208,5.208,0,0,0,942.885,1076.184Z" transform="translate(-937.854 -1070.63)" fill="#fff" opacity="0.57"/>
                            <path id="Path_865" data-name="Path 865" d="M942.885,1076.184c.4-.487.667-.809.566-1.207a.9.9,0,0,0-.55-.574,2.146,2.146,0,0,1,1.544.357,2.121,2.121,0,0,1,.6.638.894.894,0,0,0-.774-.042c-.37.18-.444.591-.558,1.212a5.237,5.237,0,0,0,.026,1.822,5.931,5.931,0,0,0,.251,1.124l-.059.068a3.62,3.62,0,0,1-.811.666,2.543,2.543,0,0,1-.843.361,2.258,2.258,0,0,1-.482.047l-.783.589-.055-1a2.9,2.9,0,0,1-.373-.669,3.168,3.168,0,0,1-.144-1.694,5.853,5.853,0,0,0,1.04-.542A5.208,5.208,0,0,0,942.885,1076.184Z" transform="translate(-937.854 -1070.63)" fill="#ffa700"/>
                            <path id="Path_866" data-name="Path 866" d="M943.983,1076.394c-.013-.007-.028-.016-.045-.023a.509.509,0,0,0-.051-.021c-.072.1-.15.194-.232.294-.109.131-.219.253-.325.365a1.658,1.658,0,0,1,.247.087,1.708,1.708,0,0,1,.262.148c.015-.127.033-.26.056-.4C943.921,1076.688,943.951,1076.537,943.983,1076.394Z" transform="translate(-938.339 -1070.955)" fill="#1a1818"/>
                            <path id="Path_867" data-name="Path 867" d="M943.558,1078.43a5.222,5.222,0,0,0-1.239-.575q-.266.178-.549.353l-.2.123a7.2,7.2,0,0,1,1.081.4,7.126,7.126,0,0,1,1.027.582c-.019-.122-.038-.246-.055-.372C943.6,1078.767,943.576,1078.6,943.558,1078.43Z" transform="translate(-938.049 -1071.203)" fill="#1a1818"/>
                            <path id="Path_868" data-name="Path 868" d="M943.4,1080.5a6.87,6.87,0,0,0-2.623-1.239,1.46,1.46,0,0,0-.013.408,1.485,1.485,0,0,0,.086.364,10.429,10.429,0,0,1,1.026.418c.332.155.632.318.9.477a2.356,2.356,0,0,0,.624-.428Z" transform="translate(-937.915 -1071.435)" fill="#1a1818"/>
                            <path id="Path_869" data-name="Path 869" d="M941.862,1081.486l-.413.311-.025-.528a1.71,1.71,0,0,1,.438.217Z" transform="translate(-938.025 -1071.766)" fill="#1a1818"/>
                            <path id="Path_870" data-name="Path 870" d="M944.474,1069.9a.34.34,0,0,1,.161.074c.1.085.07.195.1.418.04.271.1.28.156.628.02.128.027.222.028.242a1.858,1.858,0,0,1-.045.625c-.015.055-.1.381-.208.378-.041,0-.07-.051-.074-.057-.046-.08.008-.187.039-.262a1.372,1.372,0,0,0,.075-.464,1.622,1.622,0,0,0-.183-.752.9.9,0,0,0-.161-.293c-.1-.113-.183-.12-.213-.216a.269.269,0,0,1,.092-.282A.287.287,0,0,1,944.474,1069.9Z" transform="translate(-938.473 -1069.892)" fill="#1a1818"/>
                            <path id="Path_871" data-name="Path 871" d="M948.392,1071.854a.344.344,0,0,0-.161-.075c-.126-.018-.194.073-.385.191-.233.144-.281.1-.581.285-.11.068-.186.123-.2.135a1.854,1.854,0,0,0-.448.438c-.032.046-.225.322-.155.4a.108.108,0,0,0,.092.02c.091-.016.138-.126.176-.2a1.331,1.331,0,0,1,.306-.357,1.618,1.618,0,0,1,.693-.345.879.879,0,0,1,.328-.067c.153.007.21.063.3.023a.269.269,0,0,0,.156-.252A.289.289,0,0,0,948.392,1071.854Z" transform="translate(-938.852 -1070.202)" fill="#1a1818"/>
                            <path id="Path_872" data-name="Path 872" d="M944.314,1072.283l0,.009-.01.024a.381.381,0,0,0-.021.345.253.253,0,0,0,.105.1.186.186,0,0,0,.072.017c.14,0,.241-.142.327-.469,0-.015.007-.029.011-.044a1.79,1.79,0,0,1,.585.16,1.771,1.771,0,0,1,.555.4l-.01.013c-.195.277-.24.448-.147.553a.178.178,0,0,0,.059.043.253.253,0,0,0,.145.016.36.36,0,0,0,.24-.22,1.8,1.8,0,0,1-.141,1.89c-.078.07-.226.164-.314.114-.059-.033-.047-.1-.1-.237a1.142,1.142,0,0,0-.182-.3,2.546,2.546,0,0,0-.849-.684,2.24,2.24,0,0,0-.9-.22,1.3,1.3,0,0,0-.536.056c-.085.035-.154.082-.224.053-.109-.048-.116-.244-.117-.263a1.734,1.734,0,0,1,.119-.342A1.8,1.8,0,0,1,944.314,1072.283Z" transform="translate(-938.262 -1070.283)" fill="#1a1818"/>
                          </g>
                          <path id="Path_873" data-name="Path 873" d="M946.8,1083.345h-9.717l-4.773-8.237,4.773-8.238H946.8l-.4.669h-8.93l-4.385,7.569,4.385,7.568h8.93Z" transform="translate(-932.31 -1066.87)" fill="#1a1818"/>
                        </g>
                        <path id="Path_874" data-name="Path 874" d="M918.669,1073.077l9.548-.014,4.762-8.276-4.787-8.262-9.548.014-4.762,8.276Z" transform="translate(0)" fill="#ffa700" stroke="#fff" stroke-width="0.824"/>
                        <path id="Path_875" data-name="Path 875" d="M918.669,1093.64l9.548-.014,4.762-8.276-4.787-8.262-9.548.014-4.762,8.276Z" transform="translate(0 -3.387)" fill="#ffa700" stroke="#fff" stroke-width="0.824"/>
                        <g id="Group_237" data-name="Group 237" transform="translate(933.489 1067.69)">
                          <g id="Group_236" data-name="Group 236">
                            <path id="Path_876" data-name="Path 876" d="M946.842,1076.8a4.005,4.005,0,0,1,.989,1.3,2.439,2.439,0,0,1,.226.742,2.33,2.33,0,0,1-.142,1.053,2.689,2.689,0,0,1-.5.9,1.689,1.689,0,0,1-.512.428,1.022,1.022,0,0,1-.6.161c-.288-.034-.474-.235-.717-.5a3.255,3.255,0,0,1-.511-.762,4.822,4.822,0,0,1-.418-1.514,4.982,4.982,0,0,1-.028-1.743c.1-.561.166-.911.425-1.037C945.526,1075.6,946.283,1076.287,946.842,1076.8Z" transform="translate(-938.542 -1070.862)" fill="#f8e3c9"/>
                            <path id="Path_877" data-name="Path 877" d="M940.809,1074.3a4.013,4.013,0,0,0-1.634.084,2.459,2.459,0,0,0-.712.307,2.341,2.341,0,0,0-.713.789,2.7,2.7,0,0,0-.363.963,1.7,1.7,0,0,0,0,.667,1.015,1.015,0,0,0,.264.562,1.2,1.2,0,0,0,.846.223,3.233,3.233,0,0,0,.912-.1,4.821,4.821,0,0,0,1.426-.657,5.008,5.008,0,0,0,1.35-1.1c.362-.44.589-.714.518-.994C942.578,1074.526,941.561,1074.394,940.809,1074.3Z" transform="translate(-937.355 -1070.61)" fill="#f8e3c9"/>
                            <path id="Path_878" data-name="Path 878" d="M942.885,1076.184c.4-.487.667-.809.566-1.207a.9.9,0,0,0-.55-.574,2.146,2.146,0,0,1,1.544.357,2.121,2.121,0,0,1,.6.638.894.894,0,0,0-.774-.042c-.37.18-.444.591-.558,1.212a5.237,5.237,0,0,0,.026,1.822,5.931,5.931,0,0,0,.251,1.124l-.059.068a3.62,3.62,0,0,1-.811.666,2.543,2.543,0,0,1-.843.361,2.258,2.258,0,0,1-.482.047l-.783.589-.055-1a2.9,2.9,0,0,1-.373-.669,3.168,3.168,0,0,1-.144-1.694,5.853,5.853,0,0,0,1.04-.542A5.208,5.208,0,0,0,942.885,1076.184Z" transform="translate(-937.854 -1070.63)" fill="#fff" opacity="0.57"/>
                            <path id="Path_879" data-name="Path 879" d="M942.885,1076.184c.4-.487.667-.809.566-1.207a.9.9,0,0,0-.55-.574,2.146,2.146,0,0,1,1.544.357,2.121,2.121,0,0,1,.6.638.894.894,0,0,0-.774-.042c-.37.18-.444.591-.558,1.212a5.237,5.237,0,0,0,.026,1.822,5.931,5.931,0,0,0,.251,1.124l-.059.068a3.62,3.62,0,0,1-.811.666,2.543,2.543,0,0,1-.843.361,2.258,2.258,0,0,1-.482.047l-.783.589-.055-1a2.9,2.9,0,0,1-.373-.669,3.168,3.168,0,0,1-.144-1.694,5.853,5.853,0,0,0,1.04-.542A5.208,5.208,0,0,0,942.885,1076.184Z" transform="translate(-937.854 -1070.63)" fill="#ffa700"/>
                            <path id="Path_880" data-name="Path 880" d="M943.983,1076.394c-.013-.007-.028-.016-.045-.023a.509.509,0,0,0-.051-.021c-.072.1-.15.194-.232.294-.109.131-.219.253-.325.365a1.658,1.658,0,0,1,.247.087,1.708,1.708,0,0,1,.262.148c.015-.127.033-.26.056-.4C943.921,1076.688,943.951,1076.537,943.983,1076.394Z" transform="translate(-938.339 -1070.955)" fill="#1a1818"/>
                            <path id="Path_881" data-name="Path 881" d="M943.558,1078.43a5.222,5.222,0,0,0-1.239-.575q-.266.178-.549.353l-.2.123a7.2,7.2,0,0,1,1.081.4,7.126,7.126,0,0,1,1.027.582c-.019-.122-.038-.246-.055-.372C943.6,1078.767,943.576,1078.6,943.558,1078.43Z" transform="translate(-938.049 -1071.203)" fill="#1a1818"/>
                            <path id="Path_882" data-name="Path 882" d="M943.4,1080.5a6.87,6.87,0,0,0-2.623-1.239,1.46,1.46,0,0,0-.013.408,1.485,1.485,0,0,0,.086.364,10.429,10.429,0,0,1,1.026.418c.332.155.632.318.9.477a2.356,2.356,0,0,0,.624-.428Z" transform="translate(-937.915 -1071.435)" fill="#1a1818"/>
                            <path id="Path_883" data-name="Path 883" d="M941.862,1081.486l-.413.311-.025-.528a1.71,1.71,0,0,1,.438.217Z" transform="translate(-938.025 -1071.766)" fill="#1a1818"/>
                            <path id="Path_884" data-name="Path 884" d="M944.474,1069.9a.34.34,0,0,1,.161.074c.1.085.07.195.1.418.04.271.1.28.156.628.02.128.027.222.028.242a1.858,1.858,0,0,1-.045.625c-.015.055-.1.381-.208.378-.041,0-.07-.051-.074-.057-.046-.08.008-.187.039-.262a1.372,1.372,0,0,0,.075-.464,1.622,1.622,0,0,0-.183-.752.9.9,0,0,0-.161-.293c-.1-.113-.183-.12-.213-.216a.269.269,0,0,1,.092-.282A.287.287,0,0,1,944.474,1069.9Z" transform="translate(-938.473 -1069.892)" fill="#1a1818"/>
                            <path id="Path_885" data-name="Path 885" d="M948.392,1071.854a.344.344,0,0,0-.161-.075c-.126-.018-.194.073-.385.191-.233.144-.281.1-.581.285-.11.068-.186.123-.2.135a1.854,1.854,0,0,0-.448.438c-.032.046-.225.322-.155.4a.108.108,0,0,0,.092.02c.091-.016.138-.126.176-.2a1.331,1.331,0,0,1,.306-.357,1.618,1.618,0,0,1,.693-.345.879.879,0,0,1,.328-.067c.153.007.21.063.3.023a.269.269,0,0,0,.156-.252A.289.289,0,0,0,948.392,1071.854Z" transform="translate(-938.852 -1070.202)" fill="#1a1818"/>
                            <path id="Path_886" data-name="Path 886" d="M944.314,1072.283l0,.009-.01.024a.381.381,0,0,0-.021.345.253.253,0,0,0,.105.1.186.186,0,0,0,.072.017c.14,0,.241-.142.327-.469,0-.015.007-.029.011-.044a1.79,1.79,0,0,1,.585.16,1.771,1.771,0,0,1,.555.4l-.01.013c-.195.277-.24.448-.147.553a.178.178,0,0,0,.059.043.253.253,0,0,0,.145.016.36.36,0,0,0,.24-.22,1.8,1.8,0,0,1-.141,1.89c-.078.07-.226.164-.314.114-.059-.033-.047-.1-.1-.237a1.142,1.142,0,0,0-.182-.3,2.546,2.546,0,0,0-.849-.684,2.24,2.24,0,0,0-.9-.22,1.3,1.3,0,0,0-.536.056c-.085.035-.154.082-.224.053-.109-.048-.116-.244-.117-.263a1.734,1.734,0,0,1,.119-.342A1.8,1.8,0,0,1,944.314,1072.283Z" transform="translate(-938.262 -1070.283)" fill="#1a1818"/>
                          </g>
                        </g>
                        <path id="Path_887" data-name="Path 887" d="M918.669,1073.077l9.548-.014,4.762-8.276-4.787-8.262-9.548.014-4.762,8.276Z" transform="translate(0)" fill="none" stroke="#fff" stroke-width="0.824"/>
                        <path id="Path_888" data-name="Path 888" d="M918.669,1077.247l9.548.014,4.762,8.276-4.787,8.262-9.548-.014-4.762-8.276Z" transform="translate(0 -3.413)" fill="none" stroke="#fff" stroke-width="0.824"/>
                      </g>
                    </svg>
                  </div>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article class="hamburger-icon">
                  <div
                    (click)="toggleMenu()"
                    class="background-container"
                  >
                    <svg class="menu" xmlns="http://www.w3.org/2000/svg" width="30.342" height="22" viewBox="0 0 30.342 22">
                      <g id="menu_bar" data-name="menu bar" transform="translate(-234.658 -33.871)">
                        <line id="Line_4" data-name="Line 4" x1="26.342" transform="translate(236.658 35.871)" fill="none" stroke="#ffa700" stroke-linecap="round" stroke-width="4"/>
                        <line id="Line_5" data-name="Line 5" x1="26.342" transform="translate(236.658 44.871)" fill="none" stroke="#ffa700" stroke-linecap="round" stroke-width="4"/>
                        <line id="Line_6" data-name="Line 6" x1="26.342" transform="translate(236.658 53.871)" fill="none" stroke="#ffa700" stroke-linecap="round" stroke-width="4"/>
                      </g>
                    </svg>
                  </div>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
          </div>
          <div
            *ngIf="!(isMobile && !isLandscape)"
            [ngClass]="{
              'hex-container': true,
              'mobile': isMobile,
              'portrait-view': !isMobile && !isLandscape
            }"
          >
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article class="home-icon">
                  <div
                    (click)="handleNavigateApp()"
                    class="background-container"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="30.358" height="34.687" viewBox="0 0 30.358 34.687">
                      <g id="classhive_logo" data-name="classhive logo" transform="translate(-913.407 -1056.112)">
                        <g id="Group_235" data-name="Group 235" transform="translate(929.275 1065.167)">
                          <g id="Group_234" data-name="Group 234" transform="translate(4.214 2.523)">
                            <path id="Path_862" data-name="Path 862" d="M946.842,1076.8a4.005,4.005,0,0,1,.989,1.3,2.439,2.439,0,0,1,.226.742,2.33,2.33,0,0,1-.142,1.053,2.689,2.689,0,0,1-.5.9,1.689,1.689,0,0,1-.512.428,1.022,1.022,0,0,1-.6.161c-.288-.034-.474-.235-.717-.5a3.255,3.255,0,0,1-.511-.762,4.822,4.822,0,0,1-.418-1.514,4.982,4.982,0,0,1-.028-1.743c.1-.561.166-.911.425-1.037C945.526,1075.6,946.283,1076.287,946.842,1076.8Z" transform="translate(-938.542 -1070.862)" fill="#f8e3c9"/>
                            <path id="Path_863" data-name="Path 863" d="M940.809,1074.3a4.013,4.013,0,0,0-1.634.084,2.459,2.459,0,0,0-.712.307,2.341,2.341,0,0,0-.713.789,2.7,2.7,0,0,0-.363.963,1.7,1.7,0,0,0,0,.667,1.015,1.015,0,0,0,.264.562,1.2,1.2,0,0,0,.846.223,3.233,3.233,0,0,0,.912-.1,4.821,4.821,0,0,0,1.426-.657,5.008,5.008,0,0,0,1.35-1.1c.362-.44.589-.714.518-.994C942.578,1074.526,941.561,1074.394,940.809,1074.3Z" transform="translate(-937.355 -1070.61)" fill="#f8e3c9"/>
                            <path id="Path_864" data-name="Path 864" d="M942.885,1076.184c.4-.487.667-.809.566-1.207a.9.9,0,0,0-.55-.574,2.146,2.146,0,0,1,1.544.357,2.121,2.121,0,0,1,.6.638.894.894,0,0,0-.774-.042c-.37.18-.444.591-.558,1.212a5.237,5.237,0,0,0,.026,1.822,5.931,5.931,0,0,0,.251,1.124l-.059.068a3.62,3.62,0,0,1-.811.666,2.543,2.543,0,0,1-.843.361,2.258,2.258,0,0,1-.482.047l-.783.589-.055-1a2.9,2.9,0,0,1-.373-.669,3.168,3.168,0,0,1-.144-1.694,5.853,5.853,0,0,0,1.04-.542A5.208,5.208,0,0,0,942.885,1076.184Z" transform="translate(-937.854 -1070.63)" fill="#fff" opacity="0.57"/>
                            <path id="Path_865" data-name="Path 865" d="M942.885,1076.184c.4-.487.667-.809.566-1.207a.9.9,0,0,0-.55-.574,2.146,2.146,0,0,1,1.544.357,2.121,2.121,0,0,1,.6.638.894.894,0,0,0-.774-.042c-.37.18-.444.591-.558,1.212a5.237,5.237,0,0,0,.026,1.822,5.931,5.931,0,0,0,.251,1.124l-.059.068a3.62,3.62,0,0,1-.811.666,2.543,2.543,0,0,1-.843.361,2.258,2.258,0,0,1-.482.047l-.783.589-.055-1a2.9,2.9,0,0,1-.373-.669,3.168,3.168,0,0,1-.144-1.694,5.853,5.853,0,0,0,1.04-.542A5.208,5.208,0,0,0,942.885,1076.184Z" transform="translate(-937.854 -1070.63)" fill="#ffa700"/>
                            <path id="Path_866" data-name="Path 866" d="M943.983,1076.394c-.013-.007-.028-.016-.045-.023a.509.509,0,0,0-.051-.021c-.072.1-.15.194-.232.294-.109.131-.219.253-.325.365a1.658,1.658,0,0,1,.247.087,1.708,1.708,0,0,1,.262.148c.015-.127.033-.26.056-.4C943.921,1076.688,943.951,1076.537,943.983,1076.394Z" transform="translate(-938.339 -1070.955)" fill="#1a1818"/>
                            <path id="Path_867" data-name="Path 867" d="M943.558,1078.43a5.222,5.222,0,0,0-1.239-.575q-.266.178-.549.353l-.2.123a7.2,7.2,0,0,1,1.081.4,7.126,7.126,0,0,1,1.027.582c-.019-.122-.038-.246-.055-.372C943.6,1078.767,943.576,1078.6,943.558,1078.43Z" transform="translate(-938.049 -1071.203)" fill="#1a1818"/>
                            <path id="Path_868" data-name="Path 868" d="M943.4,1080.5a6.87,6.87,0,0,0-2.623-1.239,1.46,1.46,0,0,0-.013.408,1.485,1.485,0,0,0,.086.364,10.429,10.429,0,0,1,1.026.418c.332.155.632.318.9.477a2.356,2.356,0,0,0,.624-.428Z" transform="translate(-937.915 -1071.435)" fill="#1a1818"/>
                            <path id="Path_869" data-name="Path 869" d="M941.862,1081.486l-.413.311-.025-.528a1.71,1.71,0,0,1,.438.217Z" transform="translate(-938.025 -1071.766)" fill="#1a1818"/>
                            <path id="Path_870" data-name="Path 870" d="M944.474,1069.9a.34.34,0,0,1,.161.074c.1.085.07.195.1.418.04.271.1.28.156.628.02.128.027.222.028.242a1.858,1.858,0,0,1-.045.625c-.015.055-.1.381-.208.378-.041,0-.07-.051-.074-.057-.046-.08.008-.187.039-.262a1.372,1.372,0,0,0,.075-.464,1.622,1.622,0,0,0-.183-.752.9.9,0,0,0-.161-.293c-.1-.113-.183-.12-.213-.216a.269.269,0,0,1,.092-.282A.287.287,0,0,1,944.474,1069.9Z" transform="translate(-938.473 -1069.892)" fill="#1a1818"/>
                            <path id="Path_871" data-name="Path 871" d="M948.392,1071.854a.344.344,0,0,0-.161-.075c-.126-.018-.194.073-.385.191-.233.144-.281.1-.581.285-.11.068-.186.123-.2.135a1.854,1.854,0,0,0-.448.438c-.032.046-.225.322-.155.4a.108.108,0,0,0,.092.02c.091-.016.138-.126.176-.2a1.331,1.331,0,0,1,.306-.357,1.618,1.618,0,0,1,.693-.345.879.879,0,0,1,.328-.067c.153.007.21.063.3.023a.269.269,0,0,0,.156-.252A.289.289,0,0,0,948.392,1071.854Z" transform="translate(-938.852 -1070.202)" fill="#1a1818"/>
                            <path id="Path_872" data-name="Path 872" d="M944.314,1072.283l0,.009-.01.024a.381.381,0,0,0-.021.345.253.253,0,0,0,.105.1.186.186,0,0,0,.072.017c.14,0,.241-.142.327-.469,0-.015.007-.029.011-.044a1.79,1.79,0,0,1,.585.16,1.771,1.771,0,0,1,.555.4l-.01.013c-.195.277-.24.448-.147.553a.178.178,0,0,0,.059.043.253.253,0,0,0,.145.016.36.36,0,0,0,.24-.22,1.8,1.8,0,0,1-.141,1.89c-.078.07-.226.164-.314.114-.059-.033-.047-.1-.1-.237a1.142,1.142,0,0,0-.182-.3,2.546,2.546,0,0,0-.849-.684,2.24,2.24,0,0,0-.9-.22,1.3,1.3,0,0,0-.536.056c-.085.035-.154.082-.224.053-.109-.048-.116-.244-.117-.263a1.734,1.734,0,0,1,.119-.342A1.8,1.8,0,0,1,944.314,1072.283Z" transform="translate(-938.262 -1070.283)" fill="#1a1818"/>
                          </g>
                          <path id="Path_873" data-name="Path 873" d="M946.8,1083.345h-9.717l-4.773-8.237,4.773-8.238H946.8l-.4.669h-8.93l-4.385,7.569,4.385,7.568h8.93Z" transform="translate(-932.31 -1066.87)" fill="#1a1818"/>
                        </g>
                        <path id="Path_874" data-name="Path 874" d="M918.669,1073.077l9.548-.014,4.762-8.276-4.787-8.262-9.548.014-4.762,8.276Z" transform="translate(0)" fill="#ffa700" stroke="#fff" stroke-width="0.824"/>
                        <path id="Path_875" data-name="Path 875" d="M918.669,1093.64l9.548-.014,4.762-8.276-4.787-8.262-9.548.014-4.762,8.276Z" transform="translate(0 -3.387)" fill="#ffa700" stroke="#fff" stroke-width="0.824"/>
                        <g id="Group_237" data-name="Group 237" transform="translate(933.489 1067.69)">
                          <g id="Group_236" data-name="Group 236">
                            <path id="Path_876" data-name="Path 876" d="M946.842,1076.8a4.005,4.005,0,0,1,.989,1.3,2.439,2.439,0,0,1,.226.742,2.33,2.33,0,0,1-.142,1.053,2.689,2.689,0,0,1-.5.9,1.689,1.689,0,0,1-.512.428,1.022,1.022,0,0,1-.6.161c-.288-.034-.474-.235-.717-.5a3.255,3.255,0,0,1-.511-.762,4.822,4.822,0,0,1-.418-1.514,4.982,4.982,0,0,1-.028-1.743c.1-.561.166-.911.425-1.037C945.526,1075.6,946.283,1076.287,946.842,1076.8Z" transform="translate(-938.542 -1070.862)" fill="#f8e3c9"/>
                            <path id="Path_877" data-name="Path 877" d="M940.809,1074.3a4.013,4.013,0,0,0-1.634.084,2.459,2.459,0,0,0-.712.307,2.341,2.341,0,0,0-.713.789,2.7,2.7,0,0,0-.363.963,1.7,1.7,0,0,0,0,.667,1.015,1.015,0,0,0,.264.562,1.2,1.2,0,0,0,.846.223,3.233,3.233,0,0,0,.912-.1,4.821,4.821,0,0,0,1.426-.657,5.008,5.008,0,0,0,1.35-1.1c.362-.44.589-.714.518-.994C942.578,1074.526,941.561,1074.394,940.809,1074.3Z" transform="translate(-937.355 -1070.61)" fill="#f8e3c9"/>
                            <path id="Path_878" data-name="Path 878" d="M942.885,1076.184c.4-.487.667-.809.566-1.207a.9.9,0,0,0-.55-.574,2.146,2.146,0,0,1,1.544.357,2.121,2.121,0,0,1,.6.638.894.894,0,0,0-.774-.042c-.37.18-.444.591-.558,1.212a5.237,5.237,0,0,0,.026,1.822,5.931,5.931,0,0,0,.251,1.124l-.059.068a3.62,3.62,0,0,1-.811.666,2.543,2.543,0,0,1-.843.361,2.258,2.258,0,0,1-.482.047l-.783.589-.055-1a2.9,2.9,0,0,1-.373-.669,3.168,3.168,0,0,1-.144-1.694,5.853,5.853,0,0,0,1.04-.542A5.208,5.208,0,0,0,942.885,1076.184Z" transform="translate(-937.854 -1070.63)" fill="#fff" opacity="0.57"/>
                            <path id="Path_879" data-name="Path 879" d="M942.885,1076.184c.4-.487.667-.809.566-1.207a.9.9,0,0,0-.55-.574,2.146,2.146,0,0,1,1.544.357,2.121,2.121,0,0,1,.6.638.894.894,0,0,0-.774-.042c-.37.18-.444.591-.558,1.212a5.237,5.237,0,0,0,.026,1.822,5.931,5.931,0,0,0,.251,1.124l-.059.068a3.62,3.62,0,0,1-.811.666,2.543,2.543,0,0,1-.843.361,2.258,2.258,0,0,1-.482.047l-.783.589-.055-1a2.9,2.9,0,0,1-.373-.669,3.168,3.168,0,0,1-.144-1.694,5.853,5.853,0,0,0,1.04-.542A5.208,5.208,0,0,0,942.885,1076.184Z" transform="translate(-937.854 -1070.63)" fill="#ffa700"/>
                            <path id="Path_880" data-name="Path 880" d="M943.983,1076.394c-.013-.007-.028-.016-.045-.023a.509.509,0,0,0-.051-.021c-.072.1-.15.194-.232.294-.109.131-.219.253-.325.365a1.658,1.658,0,0,1,.247.087,1.708,1.708,0,0,1,.262.148c.015-.127.033-.26.056-.4C943.921,1076.688,943.951,1076.537,943.983,1076.394Z" transform="translate(-938.339 -1070.955)" fill="#1a1818"/>
                            <path id="Path_881" data-name="Path 881" d="M943.558,1078.43a5.222,5.222,0,0,0-1.239-.575q-.266.178-.549.353l-.2.123a7.2,7.2,0,0,1,1.081.4,7.126,7.126,0,0,1,1.027.582c-.019-.122-.038-.246-.055-.372C943.6,1078.767,943.576,1078.6,943.558,1078.43Z" transform="translate(-938.049 -1071.203)" fill="#1a1818"/>
                            <path id="Path_882" data-name="Path 882" d="M943.4,1080.5a6.87,6.87,0,0,0-2.623-1.239,1.46,1.46,0,0,0-.013.408,1.485,1.485,0,0,0,.086.364,10.429,10.429,0,0,1,1.026.418c.332.155.632.318.9.477a2.356,2.356,0,0,0,.624-.428Z" transform="translate(-937.915 -1071.435)" fill="#1a1818"/>
                            <path id="Path_883" data-name="Path 883" d="M941.862,1081.486l-.413.311-.025-.528a1.71,1.71,0,0,1,.438.217Z" transform="translate(-938.025 -1071.766)" fill="#1a1818"/>
                            <path id="Path_884" data-name="Path 884" d="M944.474,1069.9a.34.34,0,0,1,.161.074c.1.085.07.195.1.418.04.271.1.28.156.628.02.128.027.222.028.242a1.858,1.858,0,0,1-.045.625c-.015.055-.1.381-.208.378-.041,0-.07-.051-.074-.057-.046-.08.008-.187.039-.262a1.372,1.372,0,0,0,.075-.464,1.622,1.622,0,0,0-.183-.752.9.9,0,0,0-.161-.293c-.1-.113-.183-.12-.213-.216a.269.269,0,0,1,.092-.282A.287.287,0,0,1,944.474,1069.9Z" transform="translate(-938.473 -1069.892)" fill="#1a1818"/>
                            <path id="Path_885" data-name="Path 885" d="M948.392,1071.854a.344.344,0,0,0-.161-.075c-.126-.018-.194.073-.385.191-.233.144-.281.1-.581.285-.11.068-.186.123-.2.135a1.854,1.854,0,0,0-.448.438c-.032.046-.225.322-.155.4a.108.108,0,0,0,.092.02c.091-.016.138-.126.176-.2a1.331,1.331,0,0,1,.306-.357,1.618,1.618,0,0,1,.693-.345.879.879,0,0,1,.328-.067c.153.007.21.063.3.023a.269.269,0,0,0,.156-.252A.289.289,0,0,0,948.392,1071.854Z" transform="translate(-938.852 -1070.202)" fill="#1a1818"/>
                            <path id="Path_886" data-name="Path 886" d="M944.314,1072.283l0,.009-.01.024a.381.381,0,0,0-.021.345.253.253,0,0,0,.105.1.186.186,0,0,0,.072.017c.14,0,.241-.142.327-.469,0-.015.007-.029.011-.044a1.79,1.79,0,0,1,.585.16,1.771,1.771,0,0,1,.555.4l-.01.013c-.195.277-.24.448-.147.553a.178.178,0,0,0,.059.043.253.253,0,0,0,.145.016.36.36,0,0,0,.24-.22,1.8,1.8,0,0,1-.141,1.89c-.078.07-.226.164-.314.114-.059-.033-.047-.1-.1-.237a1.142,1.142,0,0,0-.182-.3,2.546,2.546,0,0,0-.849-.684,2.24,2.24,0,0,0-.9-.22,1.3,1.3,0,0,0-.536.056c-.085.035-.154.082-.224.053-.109-.048-.116-.244-.117-.263a1.734,1.734,0,0,1,.119-.342A1.8,1.8,0,0,1,944.314,1072.283Z" transform="translate(-938.262 -1070.283)" fill="#1a1818"/>
                          </g>
                        </g>
                        <path id="Path_887" data-name="Path 887" d="M918.669,1073.077l9.548-.014,4.762-8.276-4.787-8.262-9.548.014-4.762,8.276Z" transform="translate(0)" fill="none" stroke="#fff" stroke-width="0.824"/>
                        <path id="Path_888" data-name="Path 888" d="M918.669,1077.247l9.548.014,4.762,8.276-4.787,8.262-9.548-.014-4.762-8.276Z" transform="translate(0 -3.413)" fill="none" stroke="#fff" stroke-width="0.824"/>
                      </g>
                    </svg>
                  </div>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article class="hamburger-icon">
                  <div
                    (click)="toggleMenu()"
                    class="background-container"
                  >
                    <svg class="menu" xmlns="http://www.w3.org/2000/svg" width="30.342" height="22" viewBox="0 0 30.342 22">
                      <g id="menu_bar" data-name="menu bar" transform="translate(-234.658 -33.871)">
                        <line id="Line_4" data-name="Line 4" x1="26.342" transform="translate(236.658 35.871)" fill="none" stroke="#ffa700" stroke-linecap="round" stroke-width="4"/>
                        <line id="Line_5" data-name="Line 5" x1="26.342" transform="translate(236.658 44.871)" fill="none" stroke="#ffa700" stroke-linecap="round" stroke-width="4"/>
                        <line id="Line_6" data-name="Line 6" x1="26.342" transform="translate(236.658 53.871)" fill="none" stroke="#ffa700" stroke-linecap="round" stroke-width="4"/>
                      </g>
                    </svg>
                  </div>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
            <div class="col">
              <section>
                <article>
                </article>
                <article>
                </article>
                <article>
                </article>
              </section>
            </div>
          </div>
        </div>
        <div id="main-content">
          <div class="content">
            <ion-router-outlet></ion-router-outlet>
          </div>
        </div>
      </div>
    </div>
  </ion-content>
</ion-app>
